import { createPortal } from "react-dom";

import { useEffect, useState } from "react";
import "../../styles/_popup.scss";

import type { AcceptResponse } from "../../types";
import { Error } from "./Error";
import { FormContainer } from "./FormContainer";
import { Success } from "./Success";

type PopupProps = {
  closePopup: () => void;
  setResult: (result: AcceptResponse[]) => void;
};

export const Popup = ({
  closePopup,
  setResult,
}: PopupProps): React.ReactPortal | null => {
  const [formStatus, setFormStatus] = useState<"initial" | "error" | "success">(
    "initial",
  );
  const setClosePopup = () => closePopup();
  const setInitialFormStatus = () => setFormStatus("initial");

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const setResultAndFormStatus = (result: AcceptResponse[]) => {
    setResult(result);
    if (result.length === 0) setFormStatus("error");
    else setFormStatus("success");
  };

  const Views = {
    error: <Error closePopup={setClosePopup} openForm={setInitialFormStatus} />,
    success: <Success closePopup={setClosePopup} />,
    initial: (
      <FormContainer
        closePopup={setClosePopup}
        setResult={setResultAndFormStatus}
      />
    ),
  };

  return createPortal(
    <div className="accept-button-popup-71d72f0d-8486-4d9d-b58c-a5b9facf4701">
      {Views[formStatus]}
    </div>,
    document.body,
  );
};
